import { render, staticRenderFns } from "./LightRGB.vue?vue&type=template&id=65b6c962&"
import script from "./LightRGB.vue?vue&type=script&lang=ts&"
export * from "./LightRGB.vue?vue&type=script&lang=ts&"
import style0 from "./LightRGB.vue?vue&type=style&index=0&id=65b6c962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports